import type { Wardrobe as WardrobeContent } from '../lib/content';
import { IconExternal } from './Icon';

/**
 * The planner sits once, at the top of the schedule — not repeated on every
 * event, which carries only its own dress code (D41). The PDF is linked rather
 * than embedded: a PDF viewer inside a mobile web page is worse than the
 * phone's own (D39).
 */
export default function Wardrobe({ content, full = false }: { content: WardrobeContent; full?: boolean }) {
  return (
    <div className="card wardrobe">
      <div className="wardrobe-title">{content.title}</div>
      <p>{content.intro}</p>
      {full && content.weather && <p><strong>Khao Lak weather:</strong> {content.weather}</p>}
      {content.pdfUrl && (
        <a
          className="btn btn-secondary btn-block"
          style={{ minHeight: 44, background: 'var(--color-bg)', gap: 8, marginTop: 2 }}
          href={content.pdfUrl} target="_blank" rel="noreferrer noopener"
        >
          Open the full planner (PDF) <IconExternal size={15} />
        </a>
      )}
    </div>
  );
}
